import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Amplify } from 'aws-amplify'
import { Toaster } from 'react-hot-toast'

import { RootRouter } from './router/RootRouter'
import { DesignSystemProvider } from './design-system'
import { ToastCard } from './design-system/components/Toast'
import { ErrorBoundary } from './components/ErrorBoundary'
import { awsAmplifyConfig } from './config'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-responsive-modal/styles.css'

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './design-system/css/variables.css'

const ENV = process.env.REACT_APP_DEV_ENV || 'dev'
Amplify.configure(awsAmplifyConfig[ENV])

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
})

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {/* Spectrum is the site-wide theme pack. createShellTheme() is a strict
            superset of the legacy editorTheme contract, so pre-existing pages
            keep rendering while picking up the new tokens. */}
        <DesignSystemProvider defaultThemeId='spectrum'>
          <RouterProvider router={RootRouter} />
          {/* One toast card, dark "night" chrome regardless of the page underneath.
              Position + timing: top-right on standard app chrome; success/info
              auto-dismiss, errors stay until closed (a failure the user didn't
              get to read before it vanished is worse than no toast at all). */}
          <Toaster
            position='top-right'
            toastOptions={{
              duration: 3200,
              success: { duration: 3200 },
              error: { duration: Infinity },
            }}
          >
            {(t) => <ToastCard toast={t} />}
          </Toaster>
        </DesignSystemProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
